import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AccountInfo } from '@azure/msal-browser';
import './Header.scss';

import IconBars from '../../assets/icons/bars.svg';
import IconCross from '../../assets/icons/cross-icon.svg';

type IProp = {
  centered?: boolean;
  applicationName: string;
  activeUser: AccountInfo | undefined;
  logoImage: string;
  accountImage: string;
  authInProgress: boolean;
  isAuthenticated: boolean;
  showTestBanner?: boolean;
  hamburgerMenu?: React.ReactElement;
  login?: () => Promise<void>;
  logout?: () => void;
  accountImageClick?: () => void;
  loginText?: string;
  logoutText?: string;
};

type IUserIcon = {
  activeUser: AccountInfo | undefined;
  accountImage: string;
  isBtn?: boolean;
};

function UserIcon({ activeUser, accountImage, isBtn }: IUserIcon) {
  // @ts-ignore
  if (activeUser?.idTokenClaims?.user_type === 'Internal') {
    return <div className={'mdir-user'} style={{ cursor: isBtn ? 'pointer' : 'default'}} />;
  }
  // @ts-ignore
  if (activeUser?.idTokenClaims?.idp_code === 'IdPorten') {
    return <div className={'idporten-user'} style={{ cursor: isBtn ? 'pointer' : 'default'}} />;
  }
  // @ts-ignore
  if (activeUser?.idTokenClaims?.idp_code === 'Statsforvalteren') {
    return <div className={'statsforvalteren-user'} style={{ cursor: isBtn ? 'pointer' : 'default'}} />;
  }
  return <img className={'user-image'} src={accountImage} alt='' style={{ cursor: isBtn ? 'pointer' : 'default'}} />;
}
export function Header({
  centered,
  applicationName,
  activeUser,
  logoImage,
  accountImage,
  authInProgress,
  isAuthenticated,
  hamburgerMenu,
  showTestBanner,
  login,
  logout,
  accountImageClick,
  loginText,
  logoutText
}: IProp) {
  const handleLogoutClick = () => {
    if (logout) {
      logout();
    }
  };

  const handleLoginClick = () => {
    if (login) {
      login();
    }
  };

  const handleAccountImageClick = () => {
    if (accountImageClick) {
      accountImageClick();
    }
  }

  const showUserInfo =
    !authInProgress && (isAuthenticated || (!isAuthenticated && login));

  const hasLogin = !isAuthenticated && login;
  const hasLogout = isAuthenticated;

  const containerClass = centered
    ? 'header-container-centered'
    : hamburgerMenu
    ? 'header-container-max-hamburger'
    : 'header-container-max';

  return (
    <div className={'header'}>
      {hamburgerMenu && <HamburgerMenu hamburgerMenu={hamburgerMenu} />}

      <div className={`${'header-container'} ${containerClass}`}>
        <Link to='/'>
          <div className={'logo-group'}>
            <div className={'logo-container'}>
              <img src={logoImage} className={'logo-image'} alt='' />
              {showTestBanner && <div className={'logo-banner'}>TEST</div>}
            </div>

            <div className={'logo-divider'} />
            <div className={'sitename-text'}>{applicationName}</div>
          </div>
        </Link>

        {showUserInfo && (
          <div className={'user-group'}>
            <div
              role='button'
              tabIndex={0}
              className={'user-image-container'}
              onKeyPress={handleAccountImageClick}
              onClick={handleAccountImageClick}
            >
              <UserIcon
                activeUser={activeUser}
                accountImage={accountImage}
                isBtn={!!accountImageClick}
              />
            </div>
            <div className={'user-text'}>
              {hasLogout && (
                <React.Fragment>
                  <div>
                    <span className={'user-name'}>
                      {/* {JSON.stringify(activeUser?.idTokenClaims)} */}
                      {activeUser?.name}
                    </span>
                    <br />
                    <a
                      id='btnLogout'
                      role='button'
                      tabIndex={0}
                      className={'user-action'}
                      onKeyPress={handleLogoutClick}
                      onClick={handleLogoutClick}
                    >
                      {logoutText ?? 'Logg ut'}
                    </a>
                  </div>
                </React.Fragment>
              )}
              {hasLogin && (
                <a
                  id='btnLogin'
                  role='button'
                  tabIndex={0}
                  className={'user-action'}
                  onKeyPress={handleLoginClick}
                  onClick={handleLoginClick}
                >
                  {loginText ?? 'Logg inn'}
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

type IHamburgerMenu = {
  hamburgerMenu: React.ReactElement;
};

function HamburgerMenu({ hamburgerMenu }: IHamburgerMenu) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  return (
    <div
      role='button'
      tabIndex={0}
      className={`${'hamburger'} d-block d-md-none`}
      aria-label='Toggle menu'
      onClick={toggle}
      onKeyPress={toggle}
    >
      {isOpen ? (
        <IconCross className={'icon'} />
      ) : (
        <IconBars className={'icon'} />
      )}

      {isOpen && hamburgerMenu}
    </div>
  );
}
